import { alpha, Box } from '@mui/material'

import { ItemBadgeProps, ItemIconProps } from '#/components/AdvancedSearch/types'

/** Quadrado colorido de ícone */
export function ItemIcon({ background, color, icon }: ItemIconProps) {
  return (
    <Box
      sx={{
        alignItems: 'center',
        backgroundColor: background ?? alpha(color, 0.12),
        borderRadius: 2,
        color,
        display: 'flex',
        height: 32,
        justifyContent: 'center',
        width: 32,
      }}
    >
      {icon}
    </Box>
  )
}

/** Bolinha colorida usada como marcador de categoria */
export function ItemBadge({ color, sx }: ItemBadgeProps) {
  return <Box sx={{ backgroundColor: color, borderRadius: '50%', height: 8, width: 8, ...sx }} />
}
